'use client'

import { User } from 'lucide-react'
import { ReactNode } from 'react'
interface ChatAvatarProps {
  icon?: ReactNode
  name?: string
  size?: 'sm' | 'md' | 'lg'
  className?: string
}
const sizeClasses = {
  sm: 'h-8 w-8',
  md: 'h-10 w-10',
  lg: 'h-12 w-12'
} as const
export function ChatAvatar({
  icon = <User />,
  name = "Assistant",
  size = 'lg',
  className = ''
}: ChatAvatarProps) {
  return (
    <div className="flex flex-col items-center justify-center">
      <div className={`
        ${sizeClasses[size]}
        border border-border rounded-full border-2 border-black
        flex items-center justify-center
        ${className}
      `}>
        {icon}
      </div>
      {name && (
        <div className="text-base font-medium mt-2">{name}</div>
      )}
    </div>
  )
} 
